<template>
	<div class="event-header">
		<div v-if="event && event.showOfficialAgencyTitle" class="label">{{translation.officialAgency}}</div>

		<div class="main">
			<div class="infos">
				<h1 class="title">{{event? translate(event).name: ''}} - {{event? event.shortName: ''}}</h1>
				<h2 class="period-location">
					<span class="period">{{periodLabel(event)}}</span>
					<span class="location">{{event.local? event.local.name: ''}}</span>
					<span class="destination">{{event.destination.name.toUpperCase()}}</span>
				</h2>
				<a class="email" :href="'mailto:'+event.email">{{event.email}}</a>
			</div>
			<router-link :to="homePath" v-if="event.showEventLogo">
				<img class="event-logo" :src="getStorageUrl(translate(event).imagePath)"/>
			</router-link>
		</div>
	</div>
</template>

<script>
import { getStorageUrl } from '../../util';
import moment from 'moment';
import { translate } from '../../assets/translations';

export default {
	props: ['event'],
	computed: {
		translation() {
			return translate(this.$store.state.language).eventHeader;
		},
	},
	data() {
		return {
			homePath: this.$route.path,
		}
	},
	methods: {
		getStorageUrl,
		periodLabel(event) {
			return moment(event.startDate).format('DD/MM/YYYY')
			+ " até " + moment(event.endDate).format('DD/MM/YYYY');
		},
		translate(event) {
			let current = this.$store.state.language;
			return event.translations.find(l => l.language.id === current.id);
		}
	}
}
</script>

<style lang="scss" scoped>
.main {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.label {
	font-size: 12px;
}

.infos {
	font-size: 12px;
	h1 { font-size: 13px; }
	h2 { font-size: 11px; }
	h2, a { color: #686868; }
	a { text-decoration: underline; }
}

img {
	max-width: 210px;
}

@media screen and (max-width: 1023px){
	.main {
		flex-direction: column;
	}
	.infos, img, .label { margin: auto; }
	.infos, .label { max-width: 520px; }
	img { order: 1}
	.infos { order: 2; }
}

.period-location > *:not(:last-child) {
	@media screen and (min-width: 561px) {
		border-right: 2px solid grey;
		padding-right: 5px;
	}

	@media screen and (max-width: 560px) {
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/event/EventHeader.vue